import { getLocalizedText } from '@/utils/i18n'
import { isOnetimePlan } from '@/utils/planUtils'

const WASH_REQUEST_CHANGE_DEADLINE_HOURS = 2

function convWashReq_(e, i, now) {
  e.dispNum = i + 1

  e.pickupChangeBtText = getLocalizedText('washRequest.change')
  e.deliveryChangeBtText = getLocalizedText('washRequest.change')

  const pickupDt = this.dateStrToDate_(e.sched_pickup_dt)
  const deliveryDt = this.dateStrToDate_(e.sched_delivery_dt)
  const pickupHourDiff = (pickupDt.valueOf() - now.valueOf()) / 1000 / 3600
  const deliveryHourDiff = (deliveryDt.valueOf() - now.valueOf()) / 1000 / 3600

  // Business Rule No.21 変更/キャンセルは3時間前まで可能　-> 2時間に変更,キャンセル期限無し-> 変更もキャンセルも2時間に変更
  // Business Rule No.24 集荷済みのときはキャンセルボタンを消すまたは押せないようにする
  const canEditBeforePickup = !e.result_pickup_dt && pickupHourDiff > WASH_REQUEST_CHANGE_DEADLINE_HOURS
  const canEditBeforeDelivery = !e.result_delivery_dt && deliveryHourDiff > WASH_REQUEST_CHANGE_DEADLINE_HOURS
  const isPickupAbsent = e.absence_status === AbsenceStatusKey.PICKUP_ABSENT
  e.canCancel = canEditBeforePickup && !isPickupAbsent
  e.canChangePickupDt = canEditBeforePickup && !isPickupAbsent
  e.canChangeWashRequestCount = canEditBeforePickup
  e.canChangeDeliveryDt = canEditBeforeDelivery
  // 宅配ボックス暗証番号は、未集荷なら集荷予定時刻、集荷済みなら配達予定時刻を基準に変更可否を判定する
  e.canChangeDeliveryBoxPw = e.result_pickup_dt ? canEditBeforeDelivery : canEditBeforePickup

  if (e.result_pickup_dt) {
    e.pickupChangeBtText = getLocalizedText('washRequest.pickedUp')
  }

  // 単発プランの場合変更、キャンセルボタンは押せない
  if (isOnetimePlan(e.plan_id)) {
    e.canCancel = false
    e.canChangePickupDt = false
    e.canChangeWashRequestCount = false
    e.canChangeDeliveryDt = false
    e.canChangeDeliveryBoxPw = false
  }

  return e
}

function getWashRequestCurrents(orig) {
  const now = new Date()
  return orig.filter(e => {
    // まだ配達が終わってないやつ
    return !e.result_delivery_dt

  }).sort((a, b) => {
    const aVal1 = a.sched_pickup_dt
    const bVal1 = b.sched_pickup_dt
    if (aVal1 > bVal1) {
      return -1;
    } else if (aVal1 < bVal1) {
      return 1;
    } else {
      const aVal2 = a.sched_delivery_dt
      const bVal2 = b.sched_delivery_dt
      return aVal2 > bVal2 ? -1 :
        aVal2 < bVal2 ? 1 : 0;
    }
  }).map((e, i) => {
    return this.convWashReq_(e, i, now)
  })
}

function ensureMinuteWithinOptions(minutes, selectedMinute) {
  if (!Array.isArray(minutes) || minutes.length === 0) {
    return 0
  }

  if (minutes.some(minute => minute.val === selectedMinute)) {
    return selectedMinute
  }

  return 0
}

import Vue from 'vue'
import { AbsenceStatusKey } from '../consts/washRequest'
export default {
  created() {
    this.dateStrToDate_ = Vue.filter('dateStrToDate')
  },
  methods: {
    convWashReq_,
    getWashRequestCurrents,
    ensureMinuteWithinOptions,
  }
}
